var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-body-container"},[_c('div',{staticClass:"dashboard-item-panel"},[_c('RecentWorkItem',{attrs:{"items":_vm.items,"emptyText":_vm.$t('No recent work')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }